<template>
  <div class="preview-box">
    <template v-if="form && Object.keys(form).length && projectForm">
      <Divider title="基础信息"></Divider>
      <LabelRow label="计划名称：">与项目名称相同</LabelRow>
      <LabelRow label="推广身份：">{{ AMEME_TYPE_LIST.find((item) => item.value === form.awemeIdentity).label }}</LabelRow>
      <template v-if="form.awemeIdentity === AMEME_TYPE.DOUYIN && form.aweme_info">
        <LabelRow label="抖音号：">
          {{ form.aweme_info.aweme_name }}
        </LabelRow>

        <LabelRow label="主页隐藏视频：">
          <el-switch
            :value="form.video_hp_visibility"
            :active-value="VIDEO_HP_VISIBILITY.ON"
            :inactive-value="VIDEO_HP_VISIBILITY.OFF"
          ></el-switch>
        </LabelRow>
      </template>

      <template v-if="[AMEME_TYPE.AWEME_VIDEO].includes(form.awemeIdentity) && isEnableStarTaskAutoMaterialSwitch">
        <LabelRow label="抖音号："> 全部抖音号 </LabelRow>
        <LabelRow label="标题：">
          <span v-if="form.original_video_title === 'OFF'">手动添加</span>
          <span v-if="form.original_video_title === 'ON'">投放原视频标题</span>
        </LabelRow>
      </template>

      <LabelRow label="原生锚点：" v-if="isShowAnchor">
        <span v-if="form.anchor_related_type === ANCHOR_RELATED_TYPE.OFF"> 不启用 </span>
        <span v-if="form.anchor_related_type === ANCHOR_RELATED_TYPE.AUTO"> 自动生成 </span>
        <span v-if="form.anchor_related_type === ANCHOR_RELATED_TYPE.SELECT"> 手动选择 </span>
      </LabelRow>

      <LabelRow v-if="!isV3" label="素材形式：">
        <span> {{ MATERIAL_STYLE_LIST.find((item) => item.value === form.materials_type).label }} </span>
      </LabelRow>
      <LabelRow v-if="isV3" label="AIGC动态创意：">
        <el-switch :value="form.aigc_dynamic_creative_switch" active-value="ON" inactive-value="OFF"></el-switch>
      </LabelRow>

      <template v-if="form.materials_type === MATERIAL_STYLE.PROMOTION_MATERIALS">
        <LabelRow label="文本摘要：" v-if="showFormFields.text_abstract">
          <span v-if="form.text_abstract_list.length" :title="form.text_abstract_list.join('、')">
            {{ form.text_abstract_list.join('、') }}
          </span>
          <span v-else>-</span>
        </LabelRow>

        <template v-if="isBlueFlowEnable">
          <LabelRow label="蓝海流量关键词：">
            <span v-if="form.blue_flow_keywords"> {{ form.blue_flow_keywords }} </span>
            <span v-else>-</span>
          </LabelRow>
        </template>

        <!-- <template v-else>
        <LabelRow label="关键词：" v-if="showFormFields.keywords">
          <span v-if="form.keywords.length" :title="form.keywords.map((i) => i.word).join('、')">
            {{ form.keywords.map((i) => i.word).join('、') }}
          </span>
          <span v-else>-</span>
        </LabelRow>
      </template> -->
        <LabelRow label="来源：" v-if="!isV3 && form.source">{{ form.source }}</LabelRow>
        <template>
          <LabelRow label="产品名称：">{{ form.app_name }}</LabelRow>
          <LabelRow label="产品主图：">
            <el-avatar shape="square" :size="68" fit="cover" :src="form.app_image.url"></el-avatar>
          </LabelRow>
          <LabelRow label="产品卖点：">
            {{ form.selling_points_list.join('、') }}
          </LabelRow>
        </template>

        <LabelRow label="行动号召：" v-if="showFormFields.action_buttons">
          {{ form.call_to_action_buttons_list.join('、') }}
        </LabelRow>

        <template v-if="showFormFields.comment">
          <LabelRow label="评论：">
            <el-switch :value="form.is_comment_disable" active-value="ON" inactive-value="OFF"></el-switch>
          </LabelRow>
          <LabelRow v-if="!isV3" label="客户端下载视频：">
            <el-switch :value="form.ad_download_status" active-value="ON" inactive-value="OFF"></el-switch>
          </LabelRow>
        </template>

        <LabelRow label="动态创意：" v-if="!isV3 && showFormFields.dynamic_creative">
          <el-switch :value="form.dynamic_creative_switch" active-value="ON" inactive-value="OFF"></el-switch>
          <p>
            <span v-if="form.advanced_dc_settings.includes('OPTIMIZE_SEARCH_RESULTS_PAGE')">优化视频、图片、标题等搜索结果页内容</span>
            <span v-if="form.advanced_dc_settings.includes('OPTIMIZE_LANDING_PAGE')">优化落地页</span>
          </p>
        </LabelRow>
      </template>

      <LabelRow label="计划类别：">
        {{ form.brand_category_paths }}
      </LabelRow>
      <LabelRow label="品牌名称：">
        {{ form.cdp_brand_text }}
      </LabelRow>

      <!-- <LabelRow label="智能拓流：" v-if="showFormFields.auto_extend_traffic">
        <el-switch
          :value="form.auto_extend_traffic"
          :disabled="isBlueFlowEnable || isDuration"
          active-value="ON"
          inactive-value="OFF"
        ></el-switch>
      </LabelRow> -->

      <Divider title="计划预算与出价"></Divider>
      <LabelRow label="优化目标：" v-if="optimizeGoal">
        {{ EXTERNAL_ACTION_LIST.find((item) => item.value === optimizeGoal.external_action).label }}
      </LabelRow>
      <!-- 广告类型：搜索广告 -->
      <template v-if="isSearch">
        <!-- 极速智投：同项目预算，无需设置 -->
        <LabelRow label="预算：" v-if="isDuration">
          <span> 同项目预算</span>
        </LabelRow>

        <!-- 常规投放：自行设置预算 -->
        <LabelRow v-else label="预算：">
          <span> {{ form.budget }}元</span>
        </LabelRow>
      </template>

      <!-- 广告类型：通投广告 -->
      <template v-else>
        <LabelRow label="预算：" v-if="adBudgetVisible && form.budget">
          <span> {{ form.budget }}元</span>
        </LabelRow>
      </template>

      <template v-if="isSearch">
        <!-- 广告类型：搜索广告 -->
        <LabelRow label="目标出价：">同项目出价</LabelRow>
      </template>
      <template v-else>
        <template v-if="adBidVisible">
          <LabelRow label="目标出价：">
            <span v-if="form.bid_type === BID_VALUE_TYPE.FIXED">
              <span> {{ form.cpa_bid }}</span>
              <span>元</span>
            </span>
            <span v-if="form.bid_type === BID_VALUE_TYPE.RANGE">
              <span>随机出价，</span>
              <span>{{ form.bid_num_range[0] }}</span>
              <span> ~ </span>
              <span>{{ form.bid_num_range[1] }}</span>
              <span>元</span>
            </span>
          </LabelRow>

          <template v-if="optimizeGoal">
            <LabelRow label="深度优化方式：">
              {{ DEEP_BID_TYPE_LIST.find((item) => item.value === optimizeGoal.deep_bid_type).label }}
            </LabelRow>

            <template v-if="adDeepBidVisible">
              <template v-if="optimizeGoal.deep_bid_type !== DEEP_BID_TYPE.DEFAULT">
                <LabelRow label="深度优化目标：">
                  {{ DEEP_EXTERNAL_ACTION_LIST.find((item) => item.value === optimizeGoal.deep_external_action).label }}
                </LabelRow>
              </template>

              <LabelRow label="深度目标出价：">
                <span v-if="form.roi_bid_type === BID_VALUE_TYPE.FIXED"> {{ form.roi_goal }}</span>
                <span v-if="form.roi_bid_type === BID_VALUE_TYPE.RANGE">
                  <span>{{ form.roi_bid_num_range[0] }}</span>
                  <span> ~ </span>
                  <span>{{ form.roi_bid_num_range[1] }}</span>
                </span>
              </LabelRow>
            </template>
          </template>
        </template>
      </template>
    </template>
    <div class="empty" v-else>请配置计划信息</div>
  </div>
</template>

<script setup>
import { toRefs, computed, unref, inject } from 'vue'
import {
  AMEME_TYPE,
  AMEME_TYPE_LIST,
  ANCHOR_RELATED_TYPE,
  VIDEO_HP_VISIBILITY,
  BID_VALUE_TYPE,
  DEEP_EXTERNAL_ACTION_LIST,
  DEEP_BID_TYPE,
  DEEP_BID_TYPE_LIST,
  EXTERNAL_ACTION_LIST,
  BID_TYPE,
  DELIVERY_MODE,
  MARKETING_GOAL,
  MATERIAL_STYLE,
  MATERIAL_STYLE_LIST
} from '../../consts/index.js'
import Divider from '../layout/title-divider.vue'
import LabelRow from '../layout/label-row.vue'
import { useOptimizeGoalRelative } from '../../hooks/useOptimizeGoal.js'

// eslint-disable-next-line
const props = defineProps({
  form: Object,
  projectForm: Object
})
const { form, projectForm } = toRefs(props)
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })
const optimizeGoal = computed(() => {
  const { delivery_setting } = projectForm.value
  if (!delivery_setting) return false
  return delivery_setting.optimize_goal
})
// 项目是否是直播营销场景
const isLive = computed(() => projectForm.value.marketing_goal === MARKETING_GOAL.LIVE)
// 项目是否关联星广联投任务
const isRelatedStarTask = computed(() => !!projectForm.value.star_task?.star_task_id)
// 关联星广联投任务且开启自动优选素材
const isEnableStarTaskAutoMaterialSwitch = computed(
  () => !isV3.value && isRelatedStarTask.value && projectForm.value.star_auto_material_addition_switch === 'ON'
)

const { isSearch, isAll, isDuration, isBlueFlowEnable, adDeepBidVisible, adBudgetVisible, adBidVisible } =
  useOptimizeGoalRelative(projectForm)

/**
 * @description:
投放类型  项目类型 智能拓流         动态创意         品牌名称（新增） 广告类别（新增）   广告评论    行动号召                      产品相关信息               原生锚点         素材类型                          文本摘要                                   落地页          广告-关键词设置         广告预算            广告出价
搜索广告 常规投放  可设置开启和关闭  可设置开启和关闭   下拉选择        下拉选择         开启和关闭  最多10个，增加开启智能生成的开关  产品主图、产品名称、产品卖点 不启用/自动生成    视频、图片、图文（同原来普通广告一样） 最多设置10个，长度25-45个字，两个英文字符占1位 可设置10个落地页  弹窗批量手动设置或者选择 自行设置预算         同项目出价，无需设置
搜索广告 极速智投  不能关闭智能拓流   ——              ——            ——              ——         ——                           ——                        ——            视频、图片、图文（同原来普通广告一样） 最多设置10个，长度25-45个字，两个英文字符占1位 可设置10个落地页  弹窗批量手动设置或者选择  同项目预算，无需设置  同项目出价，无需设置
非搜索广告 ——     ——             新增             下拉选择        拉选择           开启和关闭  最多10个，增加开启智能生成的开关  产品主图、产品名称、产品卖点  不启用/自动生成   视频、图片、图文（同原来普通广告一样） ——                                       可设置10个落地页  ——                   原来逻辑不变         原来逻辑不变
 * @return {*}
 */
const showFormFields = computed(() => {
  return {
    // 智能拓流
    auto_extend_traffic: isSearch.value,
    // 动态创意
    dynamic_creative: isSearch.value && !isDuration.value,
    // 品牌名称
    brand_info: !isDuration.value,
    // 广告类别
    brand_category: !isDuration.value,
    // 广告评论
    comment: !isDuration.value,
    // 行动号召
    action_buttons: !isDuration.value,
    // 产品相关信息
    selling_points: !isDuration.value,
    // 原生锚点
    anchor_related_type: !isDuration.value,
    // 文本摘要
    text_abstract: isSearch.value,
    // 关键词
    keywords: isSearch.value
  }
})
const isShowAnchor = computed(() => {
  // 直播场景不显示
  if (isLive.value) return false
  return showFormFields.value.anchor_related_type && [AMEME_TYPE.AWEME_VIDEO, AMEME_TYPE.DOUYIN].includes(form.value.awemeIdentity)
})
</script>

<style lang="scss" scoped>
.preview-box {
  height: 720px;
  overflow: auto;
  padding: 10px;
  .empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
